import React, { useEffect, useRef } from "react";
import { motion, useAnimation } from "framer-motion";
import cardBack from "../../@shared/assets/back-of-card.png";
import AudioManager from "../../@shared/utils/AudioManager";

const CARD_SIZE = 140;

const TradeCardAnimation = ({ onFinish }) => {
  const cardAControls = useAnimation();
  const cardBControls = useAnimation();
  const flashControls = useAnimation();

  // Run the animation sequence on mount.
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    const timeout = setTimeout(() => {
      if (!isMounted.current) return;

      const durationIn = 0.6;
      const hangTime = 0.4;
      const totalIn = durationIn + hangTime;

      cardAControls.start({
        x: 0,
        y: 0,
        transition: { duration: durationIn, ease: "easeOut" },
      });
      cardBControls.start({
        x: 0,
        y: 0,
        transition: { duration: durationIn, ease: "easeOut" },
      });

      setTimeout(() => {
        AudioManager.playSFX("cardSwooshIn");

        if (isMounted.current) {
          flashControls.start({
            opacity: [0, 0.8, 0],
            transition: {
              duration: 0.23,
              ease: "linear",
              times: [0, 80 / 230, 1],
            },
          });

          cardAControls.start({
            x: 200,
            y: -400,
            transition: { duration: durationIn, ease: "easeIn" },
          });
          cardBControls.start({
            x: -200,
            y: 400,
            transition: { duration: durationIn, ease: "easeIn" },
          });

          cardAControls.start({
            opacity: 0,
            transition: { duration: 0.5, ease: "easeInOut" },
          });
          cardBControls.start({
            opacity: 0,
            transition: { duration: 0.5, ease: "easeInOut" },
          });
        }

        setTimeout(() => {
          if (isMounted.current && onFinish) onFinish();
        }, 500);
      }, totalIn * 1000);
    }, 0);

    return () => {
      isMounted.current = false;
      clearTimeout(timeout);
    };
  }, [cardAControls, cardBControls, flashControls, onFinish]);

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 3000,
      }}
    >
      {/* Flash Overlay */}
      <motion.div
        animate={flashControls}
        initial={{ opacity: 0 }}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "#ffffff",
          zIndex: 10000,
        }}
      />
      {/* Card A */}
      <motion.img
        src={cardBack}
        alt="Trade Card A"
        animate={cardAControls}
        initial={{ x: -200, y: 400, opacity: 1, skewX: -12 }}
        style={{
          position: "absolute",
          width: CARD_SIZE,
          height: CARD_SIZE * 1.4,
          transform: "skewX(-12deg)",
          zIndex: 2,
          boxShadow: "0px 4px 5px rgba(0,0,0,0.4)",
        }}
      />
      {/* Card B */}
      <motion.img
        src={cardBack}
        alt="Trade Card B"
        animate={cardBControls}
        initial={{ x: 200, y: -400, opacity: 1, skewX: -12 }}
        style={{
          position: "absolute",
          width: CARD_SIZE,
          height: CARD_SIZE * 1.4,
          transform: "skewX(-12deg)",
          zIndex: 1,
        }}
      />
    </div>
  );
};

export default TradeCardAnimation;
